'use strict';

angular.module('far.admin')
	.controller('MountainRoutesIndexController', function (mountainRoutes, softdeleteable) {
        (function init() {
            softdeleteable.setModel(mountainRoutes);
        })();

		var vm = {
            isDelete: function(id) {
                return softdeleteable.check(id);
            },
			delete: function(id) {
                softdeleteable.delete(id);
			},
            restore: function(id) {
                softdeleteable.restore(id);
            }
		};

		return vm;
	});
